import MapperEmbed from './MapperEmbed';
import MapperHeader from './components/MapperHeader';

interface MapperLayerShellProps {
  /** Full viewport height for embed routes; App shell uses h-full min-h-0. */
  fullViewport?: boolean;
  /** Show the header control bar (mode toolbar + Import/Find/Detect). Default true. */
  showHeader?: boolean;
  editingEnabled?: boolean;
}

/**
 * Layer-centric mapper shell — header controls + LayerPanel + map canvas.
 * No legacy farm-builder chrome. Shared by standalone /mapper and embed surfaces.
 * The mode toolbar lives in the header (showToolbar={false} on MapperEmbed) so it
 * is not duplicated as a floating control in the map area.
 */
export default function MapperLayerShell({
  fullViewport = false,
  showHeader = true,
  editingEnabled = true,
}: MapperLayerShellProps) {
  return (
    <div
      className={`relative flex w-full flex-col overflow-hidden bg-white ${
        fullViewport ? 'h-screen' : 'h-full min-h-0'
      }`}
    >
      {showHeader && <MapperHeader editingEnabled={editingEnabled} />}
      <MapperEmbed showSidePanel editingEnabled={editingEnabled} showToolbar={!showHeader} />
    </div>
  );
}
